import {Task} from './task.model';
import {WpProvider} from "./wp-provider.model";

export class TaskSearch  {
  constructor(
    public taskDueDateFrom?: any,
    public taskDueDateTo?: any,
    public assignedTo?:any,
    public county?:any,
    public task?: Task,
    public tasks?: Task[],
    public providers?: WpProvider[],
    public completionDtSw?: any,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/taskSearch.model.ts